import { createAnchorLinkCache } from "../../../utils/anchorLinks/anchorLinkCache.js";
import { SpaceMd, SpaceSm } from "@nxt-costco-com/forge-design-tokens";
import { ONE_FOURTH_MIX_AD_TYPE, HALF_AD_TYPE } from "./constants.js";
const getDataLayout = (adTypes) => {
  if (!adTypes.length) return null;
  if (isHalfBannerWithFourCorners(adTypes)) return "full_1";
  if (adTypes.length > 1 && adTypes[0] === "half") return "full_1";
  if (adTypes[0] === "half") return "large_half_banner";
  return adTypes[0];
};
const getAdSetCarouselContainerSx = ({
  hasBackground,
  hasTitle
}) => {
  const backgroundWithoutTitle = hasBackground && !hasTitle;
  return {
    paddingTop: backgroundWithoutTitle ? SpaceMd : "0px",
    paddingLeft: backgroundWithoutTitle ? SpaceSm : "0px",
    paddingRight: backgroundWithoutTitle ? SpaceMd : "0px"
  };
};
const isHalfBannerWithFourCorners = (allAdTypes) => {
  const oneFourthCount = allAdTypes.filter(
    (adType) => adType === ONE_FOURTH_MIX_AD_TYPE
  ).length;
  return allAdTypes.length === 5 && (allAdTypes[0] === HALF_AD_TYPE || allAdTypes[4] === HALF_AD_TYPE) && oneFourthCount === 4;
};
const processAdSetCostcoAnchorLinks = ({
  groupId,
  title,
  id
}) => {
  const anchorLinkCache = createAnchorLinkCache();
  anchorLinkCache.addAnchorLink({
    groupId,
    title,
    id,
    level: 1
  });
};
export {
  getAdSetCarouselContainerSx,
  getDataLayout,
  isHalfBannerWithFourCorners,
  processAdSetCostcoAnchorLinks
};
